import CampaignCustomFieldListResultModelBase from '../_generated/modelBases/campaign-custom-field-list-result-model-base';

export default class CampaignCustomFieldListResultModel extends CampaignCustomFieldListResultModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
